import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Icon } from "tabler-react";
import $ from "jquery";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import "./style.css";
import { formatDate, parseDate } from "react-day-picker/moment";

class DateRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.state = {
      startdate: undefined,
      enddate: undefined,
      displayError: false,
    };
  }

  showFromMonth() {
    const { startdate, enddate } = this.state;
    if (!startdate) {
      return;
    }
    if (moment(enddate).diff(moment(startdate), "months") < 2) {
      this.enddate.getDayPicker().showMonth(startdate);
    }
  }

  handleFromChange(startdate) {
    // Change the startdate date and focus the "enddate" input field
    this.setState({ startdate });
    const changeFormat = formatDate(startdate, "YYYY-M-D");
    this.props.getDate({ date: changeFormat, name: "startdate" });
  }

  handleToChange(enddate) {
    this.setState({ enddate }, this.showFromMonth);
    const changeFormat = formatDate(enddate, "YYYY-M-D");
    this.props.getDate({ date: changeFormat, name: "enddate" });
  }

  componentDidMount() {
    $(".DayPickerInput > input").keydown(function (event) {
      if (event.keyCode === 8 || event.keyCode === 46) {
        event.preventDefault();
        return false;
      }
    });

    this.setState({
      startdate: new Date(this.props.startdate),
      enddate: new Date(this.props.enddate),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.error !== nextProps.error &&
      this.state.displayError !== true
    ) {
      this.setState({ displayError: true });
      $(".DayPickerInput > input").addClass("form-control is-invalid");
      $(".DayPickerInput").append(
        '<span class="invalid-feedback">This field is required</span>'
      );
    }
    // May 13, 2020
    if (
      (this.props.startdate !== nextProps.startdate ||
        this.props.enddate !== nextProps.enddate) &&
      nextProps.editPolygon === true
    ) {
      this.setState({
        startdate: new Date(nextProps.startdate),
        enddate: new Date(nextProps.enddate),
      });
    } else if (
      this.props.startdate !== nextProps.startdate &&
      this.props.enddate !== nextProps.enddate &&
      nextProps.editPolygon !== true
    ) {
      this.setState({
        startdate: formatDate(new Date(nextProps.startdate), "YYYY-M-D"),
        enddate: formatDate(new Date(nextProps.enddate), "YYYY-M-D"),
      });
    }
  }

  render() {
    const { startdate, enddate } = this.state;
    const modifiers = { start: startdate, end: enddate };
    const setEndDisableField =
      this.props.editPolygon !== true
        ? { before: startdate }
        : { before: enddate };
    return (
      <>
        <span className="appendCalender input-group-prepend">
          <Icon prefix="fe" className="btn btn-primary" name="calendar" />
        </span>
        <DayPickerInput
          ref={(el) => (this.enddate = el)}
          value={enddate}
          placeholder="Expiry Date"
          format="YYYY-M-D"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            // selectedDays: [startdate, { startdate, enddate }],
            selectedDays: [enddate],
            disabledDays: setEndDisableField,
            modifiers,
            month: enddate,
            fromMonth: startdate,
            numberOfMonths: 1,
          }}
          onDayChange={this.handleToChange}
          readOnly={true}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { editPolygon } = state.drawing;
  return {
    editPolygon,
  };
}

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DateRangePicker);
